<div class="dash-content fatura-wizard-page">
  <!-- Cabeçalho Principal -->
  <header class="wizard-header">
    <div class="header-left">
      <nav class="breadcrumb-trail" aria-label="Breadcrumb">
        <a routerLink="/admin/financeiro" class="breadcrumb-link">
          <i class="ri-arrow-left-line"></i> Gestão de Faturação
        </a>
        <span class="breadcrumb-separator">/</span>
        <span class="breadcrumb-current">
          {{ editId ? 'Editar Fatura' : (corrigirId ? 'Retificar Fatura Rejeitada' : 'Nova Fatura') }}
        </span>
      </nav>
      <div class="title-row">
        <h1>
          {{ editId ? 'Editar Fatura' : (corrigirId ? 'Retificar Fatura Rejeitada' : 'Nova Fatura') }}
          <span class="step-tag">Passo {{ currentStep() }} de 4</span>
        </h1>
        @if (corrigirId && documentoOriginal) {
        <div class="rectify-alert-badge">
          <i class="ri-error-warning-line"></i>
          A retificar fatura rejeitada: <strong>{{ documentoOriginal.documentNo }}</strong>
        </div>
        }
      </div>
    </div>
    <div class="header-actions">
      <button type="button" class="btn-cancel" (click)="cancelar()">
        <i class="ri-close-line"></i> Cancelar
      </button>
      <button type="button" class="btn-draft" [disabled]="saving() || submittingAgt()" (click)="guardarRascunho()">
        <i class="ri-save-line" [class.ri-loader-4-line]="saving()" [class.animate-spin]="saving()"></i>
        {{ saving() ? 'A guardar...' : 'Guardar Rascunho' }}
      </button>
    </div>
  </header>

  <!-- Indicador de Passos (Stepper) -->
  <nav class="stepper-nav" aria-label="Passos da Emissão">
    <div class="stepper-item" [class.active]="currentStep() === 1" [class.completed]="currentStep() > 1"
      (click)="goToStep(1)">
      <div class="step-circle">1</div>
      <div class="step-meta">
        <span class="step-title">TIPO & SÉRIE</span>
        <span class="step-subtitle">Definições fiscais</span>
      </div>
    </div>
    <div class="stepper-separator"></div>

    <div class="stepper-item" [class.active]="currentStep() === 2" [class.completed]="currentStep() > 2"
      (click)="goToStep(2)">
      <div class="step-circle">2</div>
      <div class="step-meta">
        <span class="step-title">CLIENTE & POSTO</span>
        <span class="step-subtitle">Identificação & Alocação</span>
      </div>
    </div>
    <div class="stepper-separator"></div>

    <div class="stepper-item" [class.active]="currentStep() === 3" [class.completed]="currentStep() > 3"
      (click)="goToStep(3)">
      <div class="step-circle">3</div>
      <div class="step-meta">
        <span class="step-title">ITENS & SERVIÇOS</span>
        <span class="step-subtitle">Efetivos e Tarifas</span>
      </div>
    </div>
    <div class="stepper-separator"></div>

    <div class="stepper-item" [class.active]="currentStep() === 4" [class.completed]="currentStep() > 4"
      (click)="goToStep(4)">
      <div class="step-circle">4</div>
      <div class="step-meta">
        <span class="step-title">SUBMISSÃO AGT</span>
        <span class="step-subtitle">Validação e Pagamento</span>
      </div>
    </div>
  </nav>

  <!-- Loading State -->
  @if (loading()) {
  <div class="wizard-skeleton">
    <p-skeleton height="3.5rem" class="mb-3" />
    <p-skeleton height="14rem" class="mb-3" />
    <p-skeleton height="10rem" />
  </div>
  } @else {
  <!-- Formulário Principal -->
  <form [formGroup]="form" class="wizard-form-container">

    <!-- ================= PASSO 1: TIPO & SÉRIE ================= -->
    @if (currentStep() === 1) {
    <section class="step-card" aria-labelledby="step1-title">
      <div class="step-card-header">
        <span class="step-number-pill">01</span>
        <div>
          <h2 id="step1-title">Tipo de documento fiscal e série</h2>
          <p>Selecione o tipo de documento, a série ativa e as condições de pagamento.</p>
        </div>
      </div>

      <div class="info-callout">
        <i class="ri-shield-check-line callout-icon"></i>
        <div>
          <strong>Submissão prévia obrigatória (AGT):</strong>
          <span>
            O documento é criado no estado inicial <em>"Guardada"</em> com assinatura digital gerada internamente
            antes da validação final no sistema central da AGT.
          </span>
        </div>
      </div>

      <div class="form-grid-2">
        <!-- Tipo de Documento -->
        <div class="form-field">
          <label for="idTipoDocumento">Tipo de Documento <span class="required">*</span></label>
          <p-select id="idTipoDocumento" formControlName="idTipoDocumento" [options]="tiposDocumento"
            optionLabel="designacao" optionValue="id" placeholder="Selecione o Tipo" appendTo="body">
            <ng-template #item let-tipo>
              <div class="select-row">
                <span class="badge-code">{{ tipo.codigo }}</span>
                <span>{{ tipo.designacao || tipo.descricao }}</span>
              </div>
            </ng-template>
          </p-select>
          @if (form.get('idTipoDocumento')?.touched && form.get('idTipoDocumento')?.invalid) {
          <span class="field-error" role="alert">O tipo de documento é obrigatório.</span>
          }
        </div>

        <!-- Série Documental -->
        <div class="form-field">
          <label for="seriesCode">Série Documental <span class="required">*</span></label>
          <p-select id="seriesCode" formControlName="seriesCode" [options]="series" optionLabel="seriesCode"
            optionValue="seriesCode" placeholder="Selecione a Série" appendTo="body">
            <ng-template #item let-s>
              <div class="select-row">
                <strong>{{ s.seriesCode }}</strong>
                <span class="muted-text">Ano {{ s.seriesYear }} ({{ s.establishmentNumber }})</span>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>

      <div class="form-grid-2">
        <!-- Número Previsto -->
        <div class="form-field">
          <label>Número Oficial Previsto</label>
          <div class="calculated-preview-box">
            <i class="ri-file-text-line"></i>
            <span>{{ numeroOficialPrevisto }}</span>
          </div>
        </div>

        <!-- Centro de Custo / Origem -->
        <div class="form-field">
          <label>Centro de Custo / Origem</label>
          <input pInputText type="text" [disabled]="true" value="ÁREA FINANCEIRA / SEC" class="input-readonly" />
        </div>
      </div>

      <div class="form-grid-2">
        <!-- Data de Emissão -->
        <div class="form-field">
          <label for="dataEmissao">Data de Emissão <span class="required">*</span></label>
          <p-datepicker id="dataEmissao" formControlName="dataEmissao" dateFormat="dd/mm/yy" [showIcon]="true"
            appendTo="body" />
          @if (form.get('dataEmissao')?.touched && form.get('dataEmissao')?.invalid) {
          <span class="field-error" role="alert">Informe a data de emissão.</span>
          }
        </div>

        <!-- Data de Vencimento -->
        <div class="form-field">
          <label for="dataVencimento">Data de Vencimento <span class="required">*</span></label>
          <p-datepicker id="dataVencimento" formControlName="dataVencimento" dateFormat="dd/mm/yy" [showIcon]="true"
            appendTo="body" />
          @if (form.get('dataVencimento')?.touched && form.get('dataVencimento')?.invalid) {
          <span class="field-error" role="alert">Informe a data de vencimento.</span>
          }
        </div>
      </div>

      <!-- Condição de Pagamento (Atalhos) -->
      <div class="form-field">
        <label>Condição de Pagamento (Atalhos de Vencimento)</label>
        <div class="payment-terms-row">
          <button type="button" class="btn-term" [class.selected]="form.get('condicaoPagamento')?.value === 'Pronto'"
            (click)="setCondicaoPagamento(0, 'Pronto')">
            Pronto Pagamento
          </button>
          <button type="button" class="btn-term" [class.selected]="form.get('condicaoPagamento')?.value === '5 dias'"
            (click)="setCondicaoPagamento(5, '5 dias')">
            5 Dias
          </button>
          <button type="button" class="btn-term" [class.selected]="form.get('condicaoPagamento')?.value === '30 dias'"
            (click)="setCondicaoPagamento(30, '30 dias')">
            30 Dias
          </button>
        </div>
      </div>

      <div class="form-grid-3">
        <!-- Regime Fiscal -->
        <div class="form-field">
          <label>Regime Fiscal</label>
          <input pInputText type="text" formControlName="regimeFiscal" readonly class="input-readonly" />
        </div>

        <!-- Moeda -->
        <div class="form-field">
          <label>Moeda</label>
          <input pInputText type="text" formControlName="moeda" readonly class="input-readonly" />
        </div>

        <!-- Desconto Geral -->
        <div class="form-field">
          <label for="descontoGeral">Desconto Geral (%)</label>
          <p-inputnumber id="descontoGeral" formControlName="descontoGeral" [min]="0" [max]="100" suffix="%" />
        </div>
      </div>

      <!-- Modo de Contingência -->
      <div class="contingency-box">
        <label class="toggle-control">
          <input type="checkbox" formControlName="seriesContingencyIndicator" />
          <span class="toggle-slider"></span>
        </label>
        <div class="contingency-info">
          <strong>Emissão em Modo de Contingência</strong>
          <small>Ative apenas em caso de indisponibilidade oficial e comprovada dos servidores da AGT.</small>
        </div>
      </div>

      <footer class="step-card-footer">
        <button type="button" class="btn-secondary" (click)="cancelar()">
          Cancelar & Regressar
        </button>
        <div class="footer-right">
          <button type="button" class="btn-draft" [disabled]="saving()" (click)="guardarRascunho()">
            Guardar Rascunho
          </button>
          <button type="button" class="btn-primary" (click)="goToStep(2)">
            Avançar: Cliente e Posto <i class="ri-arrow-right-line"></i>
          </button>
        </div>
      </footer>
    </section>
    }

    <!-- ================= PASSO 2: CLIENTE & POSTO ================= -->
    @if (currentStep() === 2) {
    <section class="step-card" aria-labelledby="step2-title">
      <div class="step-card-header">
        <span class="step-number-pill">02</span>
        <div>
          <h2 id="step2-title">Cliente e Posto Operacional</h2>
          <p>Selecione o cliente adquirente e o posto ao qual os serviços foram prestados.</p>
        </div>
      </div>

      <div class="form-field">
        <label for="idCliente">Cliente Cadastrado <span class="required">*</span></label>
        <p-select id="idCliente" formControlName="idCliente" [options]="clientes" optionLabel="nome" optionValue="id"
          placeholder="Pesquisar e selecionar cliente..." [filter]="true" filterBy="nome,nif" appendTo="body">
          <ng-template #item let-c>
            <div class="select-client-row">
              <div>
                <strong>{{ c.nome }}</strong>
                <div class="muted-text">NIF: {{ c.nif || 'Não informado' }} · {{ c.sector || 'Geral' }}</div>
              </div>
            </div>
          </ng-template>
        </p-select>
        @if (form.get('idCliente')?.touched && form.get('idCliente')?.invalid) {
        <span class="field-error" role="alert">Selecione o cliente destinatário da fatura.</span>
        }
      </div>

      <!-- Card de Dados Fiscais do Adquirente -->
      @if (clienteSelecionado) {
      <div class="adquirente-card">
        <div class="adquirente-header">
          <i class="ri-building-line"></i>
          <h3>Dados Fiscais do Adquirente (SAF-T AO)</h3>
          <span class="badge-valid-nif"><i class="ri-checkbox-circle-fill"></i> NIF Validado</span>
        </div>
        <div class="adquirente-grid">
          <div>
            <span class="meta-label">Razão Social / Nome:</span>
            <span class="meta-val strong">{{ clienteSelecionado.nome }}</span>
          </div>
          <div>
            <span class="meta-label">NIF (Número de Contribuinte):</span>
            <span class="meta-val font-mono">{{ clienteSelecionado.nif || 'Consumidor Final' }}</span>
          </div>
          <div>
            <span class="meta-label">Morada de Faturação:</span>
            <span class="meta-val">{{ clienteSelecionado.endereco || 'Luanda, Angola' }}</span>
          </div>
          <div>
            <span class="meta-label">Canal de Envio / Email:</span>
            <span class="meta-val font-mono">{{ clienteSelecionado.email || 'faturacao@cliente.ao' }}</span>
          </div>
        </div>
      </div>
      }

      <!-- Seleção do Posto Vinculado -->
      <div class="form-field mt-4">
        <label for="idPosto">Posto Vinculado (Opcional)</label>
        <p-select id="idPosto" formControlName="idPosto" [options]="postosDoCliente" optionLabel="nome" optionValue="id"
          placeholder="Selecione o posto operacional..." [showClear]="true" appendTo="body">
          <ng-template #item let-p>
            <div class="select-row">
              <strong>{{ p.nome }}</strong>
              <span class="muted-text">({{ p.codigo || 'PST' }}) · {{ p.endereco || p.nomeMunicipio }}</span>
            </div>
          </ng-template>
        </p-select>
        <small class="help-text">Associa os serviços faturados a uma localização física contratual específica.</small>
      </div>

      @if (postoSelecionado) {
      <div class="posto-preview-card">
        <div class="posto-icon"><i class="ri-map-pin-2-line"></i></div>
        <div class="posto-details">
          <strong>{{ postoSelecionado.nome }} ({{ postoSelecionado.codigo }})</strong>
          <span>{{ postoSelecionado.endereco || postoSelecionado.nomeMunicipio }} · {{ postoSelecionado.risco || 'Risco
            Normal' }}</span>
          <div class="posto-tags">
            <span class="tag-badge"><i class="ri-shield-user-line"></i> {{ postoSelecionado.totalEfetivosAlocados ||
              postoSelecionado.numEfetivosTurno || 4 }} Vigilantes</span>
            <span class="tag-badge"><i class="ri-time-line"></i> Cobertura 24/7</span>
            <span class="tag-badge"><i class="ri-contract-line"></i> Contrato Activo</span>
          </div>
        </div>
      </div>
      }

      <footer class="step-card-footer">
        <button type="button" class="btn-secondary" (click)="goToStep(1)">
          <i class="ri-arrow-left-line"></i> Voltar: Tipo & Série
        </button>
        <div class="footer-right">
          <button type="button" class="btn-draft" [disabled]="saving()" (click)="guardarRascunho()">
            Guardar Rascunho
          </button>
          <button type="button" class="btn-primary" (click)="goToStep(3)">
            Avançar: Itens & Serviços <i class="ri-arrow-right-line"></i>
          </button>
        </div>
      </footer>
    </section>
    }

    <!-- ================= PASSO 3: ITENS & SERVIÇOS ================= -->
    @if (currentStep() === 3) {
    <section class="step-card" aria-labelledby="step3-title">
      <div class="step-card-header">
        <span class="step-number-pill">03</span>
        <div>
          <h2 id="step3-title">Artigos e Serviços Faturados</h2>
          <p>Adicione os serviços prestados, quantidades, tarifas e tributação em conformidade com a AGT.</p>
        </div>
      </div>

      <!-- Banner Informativo do Cabeçalho -->
      <div class="invoice-meta-banner">
        <div>
          <span class="banner-lbl">Cliente:</span>
          <strong>{{ clienteSelecionado?.nome || 'Cliente Selecionado' }}</strong>
        </div>
        <div>
          <span class="banner-lbl">NIF:</span>
          <span class="font-mono">{{ clienteSelecionado?.nif || '—' }}</span>
        </div>
        <div>
          <span class="banner-lbl">Moeda:</span>
          <strong>AOA (Kwanza)</strong>
        </div>
        <div>
          <span class="banner-lbl">Posto:</span>
          <span>{{ postoSelecionado?.nome || 'Geral' }}</span>
        </div>
      </div>

      <!-- Lista de Linhas -->
      <div formArrayName="lines" class="lines-container">
        <div class="lines-header-row">
          <span class="col-num">#</span>
          <span class="col-prod">Produto / Serviço</span>
          <span class="col-qtd">Qtd</span>
          <span class="col-price">Preço Unit. (Kz)</span>
          <span class="col-tax">Taxa IVA</span>
          <span class="col-total">Subtotal (Kz)</span>
          <span class="col-action"></span>
        </div>

        @for (line of lines.controls; track line; let i = $index) {
        <div [formGroupName]="i" class="line-row-card">
          <div class="row-main">
            <span class="line-index-badge">{{ i + 1 }}</span>

            <!-- Produto / Serviço -->
            <div class="cell-prod">
              <p-select formControlName="idProduct" [options]="produtos" optionLabel="productDescription"
                optionValue="id" placeholder="Selecione o serviço..." [filter]="true" appendTo="body"
                (onChange)="onProductChange(i, $event.value)">
                <ng-template #item let-p>
                  <div class="select-row">
                    <strong>{{ p.productDescription }}</strong>
                    <span class="muted-text">({{ p.productCode }}) · {{ p.unitOfMeasure }}</span>
                  </div>
                </ng-template>
              </p-select>
              @if (line.get('idProduct')?.touched && line.get('idProduct')?.invalid) {
              <span class="field-error">Selecione o produto.</span>
              }
            </div>

            <!-- Quantidade -->
            <div class="cell-qtd">
              <p-inputnumber formControlName="quantity" [min]="0.01" [maxFractionDigits]="3" placeholder="Qtd" />
            </div>

            <!-- Preço Unitário -->
            <div class="cell-price">
              <p-inputnumber formControlName="unitPrice" [min]="0" [maxFractionDigits]="2" placeholder="0,00" />
            </div>

            <!-- Tax Code -->
            <div class="cell-tax">
              <p-select formControlName="idTaxCode" [options]="taxCodes" optionValue="id" optionLabel="taxCode"
                placeholder="IVA" appendTo="body">
                <ng-template #item let-t>
                  <div class="select-row">
                    <strong>{{ t.taxCode }}</strong> ({{ t.taxPercentage }}%)
                  </div>
                </ng-template>
              </p-select>
            </div>

            <!-- Subtotal Calculado da Linha -->
            <div class="cell-total font-mono font-bold">
              {{ formatCurrency((line.get('quantity')?.value || 0) * (line.get('unitPrice')?.value || 0)) }}
            </div>

            <!-- Botão Excluir Linha -->
            <div class="cell-action">
              <button type="button" class="btn-icon-delete" title="Remover Linha" (click)="removeLine(i)">
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
          </div>

          <div class="row-sub">
            <label class="checkbox-inline">
              <input type="checkbox" formControlName="precoComImpostoIncluido" />
              <span>Preço já inclui imposto</span>
            </label>

            <!-- Motivo de Isenção se taxa for 0% -->
            @if (requiresExemption(i)) {
            <div class="exemption-select-wrap">
              <label>Motivo de Isenção <span class="required">*</span></label>
              <p-select formControlName="idTaxExemptionCode" [options]="availableExemptions(i)" optionValue="id"
                optionLabel="taxExemptionCode" placeholder="Selecione o código de isenção..." appendTo="body">
                <ng-template #item let-ex>
                  <div class="select-row">
                    <strong>{{ ex.taxExemptionCode }}</strong>
                    <span class="muted-text">{{ ex.descricao || ex.codigo }}</span>
                  </div>
                </ng-template>
              </p-select>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <button type="button" class="btn-add-item" (click)="addLine()">
        <i class="ri-add-line"></i> Adicionar Linha de Serviço
      </button>

      <!-- Painel de Totais & Resumo Financeiro -->
      <div class="financial-summary-box">
        <div class="summary-left">
          <h4>Resumo Financeiro & Retenção na Fonte</h4>
          <p>Cálculo automático de impostos em conformidade com o Decreto Presidencial n.º 3/19 e Lei 19/14.</p>
          <div class="summary-breakdown">
            <div class="breakdown-item">
              <span>Base Tributável (Serviços):</span>
              <strong class="font-mono">{{ formatCurrency(subtotalNetEstimado) }}</strong>
            </div>
            <div class="breakdown-item">
              <span>IVA Liquidado (14%):</span>
              <strong class="font-mono text-success">+ {{ formatCurrency(totalIvaEstimado) }}</strong>
            </div>
            <div class="breakdown-item">
              <span>Retenção na Fonte (Lei 19/14 - 6,5% informativo):</span>
              <strong class="font-mono text-muted">- {{ formatCurrency(retencaoEstimada) }}</strong>
            </div>
          </div>
        </div>

        <div class="summary-right">
          <span class="total-label">TOTAL LÍQUIDO A PAGAR</span>
          <span class="total-value font-mono">{{ formatCurrency(totalBrutoEstimado) }}</span>
          <small class="total-note">Valores confirmados e selados pelo backend após gravação.</small>
        </div>
      </div>

      <footer class="step-card-footer">
        <button type="button" class="btn-secondary" (click)="goToStep(2)">
          <i class="ri-arrow-left-line"></i> Voltar: Cliente & Posto
        </button>
        <div class="footer-right">
          <button type="button" class="btn-draft" [disabled]="saving()" (click)="guardarRascunho()">
            Guardar Rascunho
          </button>
          <button type="button" class="btn-primary" (click)="goToStep(4)">
            Avançar: Submissão AGT <i class="ri-arrow-right-line"></i>
          </button>
        </div>
      </footer>
    </section>
    }

    <!-- ================= PASSO 4: SUBMISSÃO & RESUMO AGT ================= -->
    @if (currentStep() === 4) {
    <section class="step-card" aria-labelledby="step4-title">
      <div class="step-card-header">
        <span class="step-number-pill">04</span>
        <div>
          <h2 id="step4-title">Validação Fiscal e Submissão AGT</h2>
          <p>Confirme os dados antes de gerar a assinatura digital e enviar à Administração Geral Tributária.</p>
        </div>
      </div>

      <!-- PRÉ-VISUALIZAÇÃO OFICIAL DA FATURA ESTILO A4 -->
      <div class="invoice-a4-preview">
        <div class="a4-watermark">PRÉ-VISUALIZAÇÃO OFICIAL</div>

        <!-- Cabeçalho A4 -->
        <div class="a4-header">
          <div class="a4-emitter">
            <div class="emitter-brand">
              <i class="ri-shield-check-fill brand-icon"></i>
              <div>
                <h3 class="company-name">SecurPro Angola</h3>
                <small>Segurança Privada, Vigilância e Tecnologias, Lda.</small>
              </div>
            </div>
            <div class="emitter-info">
              <span><strong>NIF:</strong> 5403079050 | Licença MinInt nº 088/2019</span>
              <span>Luanda Trade Center, 7º Andar, Luanda - Angola</span>
            </div>
          </div>

          <div class="a4-doc-meta">
            <div class="doc-badge-title">FACTURA</div>
            <div class="doc-number-bold font-mono">{{ numeroOficialPrevisto }}</div>
            <div class="doc-date-meta">
              <span><strong>Emissão:</strong> {{ form.get('dataEmissao')?.value | date: 'dd/MM/yyyy' }}</span>
              <span><strong>Vencimento:</strong> {{ form.get('dataVencimento')?.value | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>

        <!-- Destinatário / Adquirente -->
        <div class="a4-recipient-box">
          <span class="recipient-lbl">EXMO.(S) SENHOR(ES):</span>
          <h4 class="recipient-name">{{ clienteSelecionado?.nome }}</h4>
          <div class="recipient-details">
            <span><strong>NIF:</strong> {{ clienteSelecionado?.nif || 'Consumidor Final' }}</span>
            <span><strong>Endereço:</strong> {{ clienteSelecionado?.endereco || 'Luanda, Angola' }}</span>
            <span><strong>Email:</strong> {{ clienteSelecionado?.email || '—' }}</span>
          </div>
        </div>

        <!-- Tabela A4 de Serviços -->
        <table class="a4-table">
          <thead>
            <tr>
              <th>Descrição do Serviço / Artigo</th>
              <th class="text-center">Qtd</th>
              <th class="text-right">Preço Unit. (Kz)</th>
              <th class="text-center">Taxa IVA</th>
              <th class="text-right">Total Líquido (Kz)</th>
            </tr>
          </thead>
          <tbody>
            @for (line of lines.controls; track line; let idx = $index) {
            <tr>
              <td>
                <strong>{{ getProductName(line.get('idProduct')?.value) }}</strong>
                <small class="block-desc">Código: {{ getProductCode(line.get('idProduct')?.value) }} · Unidade: {{
                  getProductUnit(line.get('idProduct')?.value) }}</small>
              </td>
              <td class="text-center">{{ line.get('quantity')?.value }}</td>
              <td class="text-right font-mono">{{ formatCurrency(line.get('unitPrice')?.value) }}</td>
              <td class="text-center">{{ getTaxLabel(line.get('idTaxCode')?.value) }}</td>
              <td class="text-right font-mono">{{ formatCurrency((line.get('quantity')?.value || 0) *
                (line.get('unitPrice')?.value || 0)) }}</td>
            </tr>
            }
          </tbody>
        </table>

        <!-- Totais A4 & Coordenadas Bancárias -->
        <div class="a4-footer-grid">
          <div class="a4-bank-details">
            <h5>Coordenadas Bancárias Homologadas (AKZ):</h5>
            @for (c of contasBancarias; track c.banco) {
            <div class="bank-row">
              <span class="bank-name">{{ c.banco }}:</span>
              <span class="bank-iban font-mono">{{ c.iban }}</span>
            </div>
            }
          </div>

          <div class="a4-totals-box">
            <div class="tot-row">
              <span>Subtotal Ilíquido:</span>
              <span class="font-mono">{{ formatCurrency(subtotalNetEstimado) }}</span>
            </div>
            <div class="tot-row">
              <span>IVA (Taxa Normal 14%):</span>
              <span class="font-mono">{{ formatCurrency(totalIvaEstimado) }}</span>
            </div>
            <div class="tot-row grand">
              <span>TOTAL A PAGAR:</span>
              <span class="font-mono grand-val">{{ formatCurrency(totalBrutoEstimado) }}</span>
            </div>
          </div>
        </div>

        <!-- Rodapé Fiscal da AGT -->
        <div class="a4-tax-stamp">
          <div class="stamp-badge">
            <i class="ri-shield-keyhole-line"></i>
            <span>Processado por programa certificado nº 042/AGT/2024 · SecurPro ERP Core v4.1</span>
          </div>
          <div class="stamp-hash font-mono">
            Assinatura RSA 2048 SHA-256 · Selo AGT: <strong>SEDE/{{ form.get('seriesCode')?.value || '2026' }}</strong>
          </div>
        </div>
      </div>

      <footer class="step-card-footer">
        <button type="button" class="btn-secondary" (click)="goToStep(3)">
          <i class="ri-arrow-left-line"></i> Voltar: Itens & Serviços
        </button>
        <div class="footer-right">
          <button type="button" class="btn-draft" [disabled]="saving() || submittingAgt()" (click)="guardarRascunho()">
            <i class="ri-save-line"></i> Guardar Rascunho
          </button>
          <button type="button" class="btn-submit-agt" [disabled]="saving() || submittingAgt()"
            (click)="guardarESubmeter()">
            <i class="ri-send-plane-fill" [class.ri-loader-4-line]="submittingAgt()"
              [class.animate-spin]="submittingAgt()"></i>
            {{ submittingAgt() ? 'A submeter à AGT...' : 'Guardar & Submeter à AGT' }}
          </button>
        </div>
      </footer>
    </section>
    }

  </form>
  }
</div>